import { Link } from "react-router-dom";
import { useSettings } from "@/context/SettingsContext";

const COLS = [
  {
    title: "Ecosystem",
    links: [
      { label: "Moaglee CRE", to: "/cre" },
      { label: "Moaglee Capital", to: "/capital" },
      { label: "Moaglee Media", to: "/media" },
      { label: "Aspire Perspire Inspire", to: "/aspire" },
    ],
  },
  {
    title: "Network",
    links: [
      { label: "Private Network", to: "/private-network" },
      { label: "Michael Brown", to: "/michael-brown" },
      { label: "Book a Call", to: "/book-call" },
      { label: "Member Login", to: "/login" },
    ],
  },
  {
    title: "Company",
    links: [
      { label: "Privacy Policy", to: "/" },
      { label: "Terms", to: "/" },
      { label: "Contact", to: "/book-call" },
    ],
  },
];

export default function Footer() {
  const { settings } = useSettings();
  const email = settings?.content?.contact_email || "support@moaglee.com";
  return (
    <footer className="bg-[#0A0A0A] border-t border-white/10 pt-16 pb-10" data-testid="footer">
      <div className="max-w-7xl mx-auto px-6">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-10">
          <div>
            <div className="font-display text-2xl font-extrabold tracking-tight">
              MOAGLEE<span className="text-[#CC5500]">.</span>
            </div>
            <p className="text-neutral-400 text-sm mt-4 leading-relaxed max-w-xs">
              A private business ecosystem helping owners, investors, and operators create leverage through real estate, capital, media, and intelligent systems.
            </p>
            <p className="text-neutral-500 text-sm mt-4">{email}</p>
          </div>
          {COLS.map((col) => (
            <div key={col.title}>
              <p className="overline text-neutral-500 mb-4">{col.title}</p>
              <ul className="space-y-2.5">
                {col.links.map((l) => (
                  <li key={l.label}>
                    <Link to={l.to} className="text-neutral-300 text-sm hover:text-[#CC5500] transition-colors">
                      {l.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>
        <div className="border-t border-white/10 mt-12 pt-6 flex flex-col md:flex-row justify-between gap-2 text-neutral-600 text-xs">
          <p>© {new Date().getFullYear()} Moaglee. Real estate. Capital. Media. Ownership. Discipline. Legacy.</p>
          <p>Moaglee.com — Command Center</p>
        </div>
      </div>
    </footer>
  );
}
